import { workspace_v1_WorkspaceConfig } from '@antimatterhq/asl-api-ts-v1';
import { produce } from 'immer';
import { WorkspaceSchemaValues } from '@/zod/schemas/workspaceConfig/WorkspaceSchema';
import { bumpMetadataVersion } from '@/utils/util';

export const getWorkspaceInitialValues = (
  workspace: workspace_v1_WorkspaceConfig | undefined,
): WorkspaceSchemaValues => {
  return {
    defaultCustomNotebookLocation:
      workspace?.spec?.defaultCustomNotebookLocation || '',
    datasources: {
      catalogName: workspace?.spec?.datasources?.catalogName || '',
      bronzeSchema: workspace?.spec?.datasources?.bronzeSchema || '',
      silverSchema: workspace?.spec?.datasources?.silverSchema || '',
      goldSchema: workspace?.spec?.datasources?.goldSchema || '',
      checkpointLocation:
        workspace?.spec?.datasources?.checkpointLocation || '',
    },
    rules: {
      checkpointLocation: workspace?.spec?.rules?.checkpointLocation || '',
    },
  };
};

export const setWorkspaceValues = (
  workspace: workspace_v1_WorkspaceConfig,
  values: WorkspaceSchemaValues,
): workspace_v1_WorkspaceConfig => {
  return produce(workspace, (draft) => {
    draft.spec.defaultCustomNotebookLocation =
      values.defaultCustomNotebookLocation || undefined;
    draft.spec.datasources = {
      catalogName: values.datasources.catalogName,
      bronzeSchema: values.datasources.bronzeSchema,
      silverSchema: values.datasources.silverSchema,
      goldSchema: values.datasources.goldSchema,
      checkpointLocation: values.datasources.checkpointLocation || undefined,
    };
    draft.spec.rules = {
      checkpointLocation: values.rules.checkpointLocation || undefined,
    };
    bumpMetadataVersion(draft);
  });
};
